import { useConnorsApplyConfirm } from "./useConnorsApplyConfirm";

export function ConnorsApplyConfirmProvider({ children }) {
  const { ApplyConfirmDialog } = useConnorsApplyConfirm();

  return (
    <>
      {children}
      {ApplyConfirmDialog}
    </>
  );
}
